(() => {
  if (window.__WN_HOME_V2__) return;
  window.__WN_HOME_V2__ = true;

  const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const nodes = [...document.querySelectorAll('[data-wn-reveal]')];
  if (!nodes.length) return;

  if (reduced || !('IntersectionObserver' in window)) {
    nodes.forEach((node) => node.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  nodes.forEach((node, index) => {
    node.style.transitionDelay = Math.min(index * 45, 180) + 'ms';
    observer.observe(node);
  });
})();